export default __webpack_public_path__ + "static/media/spheres.00573508.wav";